// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"491":"efb97892","541":"26f71e3f","651":"7c2f7453"}[chunkId] + ".chunk.js";
};